/**
 * Single source of truth for API origin. Prefer REACT_APP_API_BASE_URL when set
 * (e.g. point a local dev client at the hosted API without running the server locally).
 *
 * Production default is api.criticai.ca (same-site with criticai.ca) so the
 * session cookie works on mobile Safari. Override only for local/dev.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.criticai.ca'
    : 'http://localhost:3001');
